import { InternalOrderStatus, OrderSources, ResnapOrderStatusMapping } from "application/order/orderConstants";
import { UserAgent } from "application/savedProjects/projectConstants";
import { RequestState } from "common/RequestState";
import { getAppConfig } from "services/configService";
import { DELETE, rawGET } from "services/httpService";

const apiUrl = () => {
  return getAppConfig().ResnapApiUrl;
};

const mapToAlbelliProject = item => {
  const createDate = new Date(item.createTime * 1000);
  return {
    CreationDate: createDate.toISOString(),
    Id: item.product,
    Links: [],
    ModificationDate: createDate.toISOString(),
    Title: item.title,
    UserAgent: UserAgent.RESNAP,
    CoverImage: item.coverImage,
    EditorUrl: item.sharedLink
  };
};
export const getProducts = async (requestInfo, channel) => {
  var response = await rawGET(requestInfo, apiUrl() + `/v1/products?channel=${channel}`)
    .then(resp => {
      return resp.ok ? resp.text() : null;
    })
    .then(text => JSON.parse(text));

  return (response && response.products && response.products.map(p => mapToAlbelliProject(p))) || [];
};

export const deleteProduct = (requestInfo, id) => {
  return DELETE(requestInfo, apiUrl() + `/v1/product/${id}`);
};

const mapStatus = resnapStatus => {
  const mappedStatus = ResnapOrderStatusMapping.find(s =>
    s.resnap.map(s => s.toLowerCase()).includes(resnapStatus.toLowerCase())
  );

  return mappedStatus?.internal || InternalOrderStatus.Confirmed;
};

const mapToAlbelliProduct = (product, orderStatus) => {
  return {
    ...product,
    productTitle: product.title,
    total: product.price.total,
    status: mapStatus(orderStatus)
  };
};

const mapToAlbelliOrder = order => {
  const orderCreationDate = order.dateOrdered ? new Date(order.dateOrdered * 1000) : new Date();
  return {
    ...order,
    id: order.order,
    vendorId: 1221, // we support only bonusprint for now
    code: order.order,
    createdAt: orderCreationDate.toISOString(),
    status: mapStatus(order.lastStatus),
    products: order.products.map(p => mapToAlbelliProduct(p, order.lastStatus)),
    subTotal: order.price.subtotal,
    shippingCosts: order.price.shipping,
    discount: order.price.discount,
    currencyCode: order.price.currency,
    total: order.price.total,
    _orderSource: OrderSources.Resnap,
    _requestState: RequestState.Finished
  };
};

export const getResnapOrders = async () => {
  const response = await rawGET({ includeToken: true }, apiUrl() + `/v1/orders?channel=bonusprint.co.uk`);
  const responseJson = response.ok ? await response.json() : null;
  return responseJson ? responseJson.orders.map(mapToAlbelliOrder) : [];
};
